module.exports = __webpack_public_path__ + "static/media/LoginResultsFromNim.7d89869c.svg";